export function Wordmark({ className }: Readonly<{ className?: string }>) {
  const classes = className ? "wordmark " + className : "wordmark";
  return (
    <span className={classes}>
      <span className="wordmark-neat">neat</span>
      <span className="wordmark-pt">PT</span>
    </span>
  );
}
